// Lo que comparten los mapas del panel (Choferes en vivo y el armado de
// recorridos): el mapa base de OpenStreetMap, el zoom suave y los marcadores
// con un número o un símbolo adentro.
import type { LatLng, LeafletLite, LMap } from "./leafletTypes";

export const OSM_TILES = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

// Zoom de a medio nivel (botones +/-) y la ruedita a la mitad de velocidad:
// de a un nivel entero el salto era demasiado grande (pedido del usuario).
export const SMOOTH_ZOOM = { zoomSnap: 0.25, zoomDelta: 0.5, wheelPxPerZoomLevel: 200 };

export type BaseMapOptions = { center: LatLng; zoom: number; maxZoom?: number; preferCanvas?: boolean };

export function createBaseMap(L: LeafletLite, el: HTMLElement, { center, zoom, maxZoom = 18, preferCanvas = false }: BaseMapOptions): LMap {
  const map = L.map(el, { zoomControl: true, preferCanvas, ...SMOOTH_ZOOM }).setView(center, zoom);
  L.tileLayer(OSM_TILES, { maxZoom, attribution: "© OpenStreetMap" }).addTo(map);
  return map;
}

// Cajita cuadrada de `size` px con `text` centrado. Se arma con el DOM y el
// texto va como textContent: aunque algún día lleve un nombre o una
// dirección, no hay HTML que interpretar (L.divIcon acepta un elemento).
// Ojo: cada marcador necesita SU elemento (Leaflet lo mueve adentro del
// marcador); por eso se crea uno por llamada y no se reutilizan íconos.
export function boxElement(size: number, text: string, style: Partial<CSSStyleDeclaration> = {}): HTMLElement {
  const el = document.createElement("div");
  Object.assign(el.style, {
    width: `${size}px`, height: `${size}px`, display: "flex", alignItems: "center", justifyContent: "center", lineHeight: "1",
  }, style);
  el.textContent = text;
  return el;
}

export const boxIcon = (L: LeafletLite, size: number, text: string, style: Partial<CSSStyleDeclaration> = {}) =>
  L.divIcon({ className: "", html: boxElement(size, text, style), iconSize: [size, size], iconAnchor: [size / 2, size / 2] });

// Número sobre un color, con borde blanco: las paradas de un recorrido.
export const numberIcon = (L: LeafletLite, text: string, color: string, { size = 24, textColor = "#fff", square = false, weight = 600 } = {}) =>
  boxIcon(L, size, text, {
    borderRadius: square ? "6px" : "50%", background: color, color: textColor, border: "2px solid #fff",
    boxShadow: "0 1px 3px rgba(0,0,0,.5)", font: `${weight} ${size >= 30 ? 13 : 11}px system-ui,sans-serif`,
  });
